import { useGetStations } from "@/entities/station";
import { Vestiging } from "@/entities/vestiging";
import {
    Button,
    Dialog,
    DialogBody,
    DialogContainer,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/shared/components";
import { Dispatch, SetStateAction } from "react";

type StopFaciliteitenDialogVariant =
    | { type: "all" }
    | { type: "station"; stationCode: string }
    | { type: "vestiging"; vestiging: Vestiging };

interface StopFaciliteitenDialogProps {
    open: boolean;
    onOpenChange: Dispatch<SetStateAction<boolean>>;
    onCancel: () => void;
    onConfirm: () => void;
    variant: StopFaciliteitenDialogVariant;
}

export function StopFaciliteitenDialog({ open, onOpenChange, onCancel, onConfirm, variant }: Readonly<StopFaciliteitenDialogProps>) {
    const { data: stations, isPending } = useGetStations();

    if (isPending) {
        return <p>Laden...</p>;
    }

    let title = "";
    let description = "";

    switch (variant.type) {
        case "all":
            title = "Stopverzoek alle faciliteiten";
            description = "Weet je zeker dat je een stopverzoek wilt sturen voor alle actieve faciliteiten?";
            break;
        case "station":
            {
                const station = stations?.find((s) => s.code.toLowerCase() === variant.stationCode);
                title = `Stopverzoek station ${station?.langeNaam}`;
                description = `Weet je zeker dat je een stopverzoek wilt sturen voor alle actieve faciliteiten op station ${station?.langeNaam}?`;
            }
            break;
        case "vestiging":
            {
                const vestigingDisplayName = Vestiging.getDisplayName(variant.vestiging);
                const station = stations?.find((s) => s.code.toLowerCase() === variant.vestiging.beheerVestiging.stationCode);
                title = `Stopverzoek vestiging ${vestigingDisplayName}`;
                description = `Weet je zeker dat je een stopverzoek wilt sturen voor ${vestigingDisplayName} in ${station?.langeNaam}?`;
            }
            break;
    }

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContainer className="max-w-md">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <DialogBody>
                    <DialogDescription>{description}</DialogDescription>
                </DialogBody>
                <DialogFooter>
                    <Button variant="tertiary" onClick={onCancel}>
                        Annuleren
                    </Button>
                    <Button variant="primary" onClick={onConfirm} destructive={true}>
                        Stopverzoek versturen
                    </Button>
                </DialogFooter>
            </DialogContainer>
        </Dialog>
    );
}
